import React from "react"
import PropTypes from "prop-types"

const IconPinLocator = ({ color, size }) => (
	<svg
		width={size}
		height="35"
		viewBox="0 0 33 35"
		fill={color}
		xmlns="http://www.w3.org/2000/svg"
	>
		<g filter="url(#filter0_d_21_35)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.35 0.906893C11.5801 0.901873 8.92197 1.82806 6.96336 3.48063C5.00475 5.13321 3.90705 7.37602 3.913 9.71312C3.913 16.3131 14.35 26.0621 14.35 26.0621C14.35 26.0621 24.787 16.3131 24.787 9.71312C24.793 7.37602 23.6953 5.13321 21.7367 3.48063C19.778 1.82806 17.1199 0.901873 14.35 0.906893ZM14.35 12.8622C12.2887 12.8622 10.6177 11.4523 10.6177 9.71312C10.6177 7.97391 12.2887 6.564 14.35 6.564C16.4113 6.564 18.0823 7.97391 18.0823 9.71312C18.0823 10.5483 17.6891 11.3493 16.9891 11.9399C16.2892 12.5305 15.3399 12.8622 14.35 12.8622V12.8622Z"
				fill={color}
				shapeRendering="crispEdges"
			/>
			<path
				d="M14.35 0.906893L14.3496 1.15689L14.3505 1.15689L14.35 0.906893ZM3.913 9.71312L4.163 9.71312L4.163 9.71248L3.913 9.71312ZM14.35 26.0621L14.1794 26.2448L14.35 26.4042L14.5207 26.2448L14.35 26.0621ZM24.787 9.71312L24.537 9.71248V9.71312H24.787ZM14.3505 0.656894C11.5266 0.651775 8.80976 1.59563 6.80214 3.28956L7.12458 3.67171C9.03418 2.06048 11.6337 1.15197 14.3496 1.15689L14.3505 0.656894ZM6.80214 3.28956C4.79323 4.98458 3.65684 7.29507 3.663 9.71375L4.163 9.71248C4.15726 7.45698 5.21627 5.28184 7.12458 3.67171L6.80214 3.28956ZM3.663 9.71312C3.663 11.423 4.33688 13.3128 5.323 15.1693C6.31141 17.0301 7.62625 18.8809 8.93627 20.5188C10.247 22.1575 11.557 23.5882 12.5391 24.609C13.0302 25.1196 13.4397 25.528 13.7266 25.809C13.8701 25.9495 13.983 26.0581 14.0601 26.1318C14.0987 26.1687 14.1283 26.1968 14.1484 26.2157C14.1585 26.2252 14.1661 26.2324 14.1713 26.2373C14.1739 26.2397 14.1759 26.2416 14.1772 26.2428C14.1779 26.2435 14.1784 26.2439 14.1788 26.2443C14.1789 26.2444 14.1791 26.2446 14.1792 26.2447C14.1793 26.2448 14.1794 26.2448 14.35 26.0621C14.5207 25.8794 14.5206 25.8794 14.5206 25.8794C14.5205 25.8793 14.5204 25.8792 14.5203 25.8791C14.52 25.8789 14.5196 25.8784 14.519 25.8779C14.5178 25.8768 14.516 25.8751 14.5136 25.8728C14.5087 25.8683 14.5014 25.8614 14.4917 25.8522C14.4723 25.8339 14.4433 25.8064 14.4055 25.7703C14.3297 25.6979 14.2184 25.5907 14.0765 25.4517C13.7926 25.1738 13.3867 24.7689 12.8994 24.2624C11.9245 23.249 10.6253 21.83 9.32674 20.2065C8.0275 18.5821 6.7331 16.7581 5.76457 14.9347C4.79375 13.107 4.163 11.3032 4.163 9.71312H3.663ZM14.35 26.0621C14.5207 26.2448 14.5207 26.2448 14.5208 26.2447C14.5209 26.2446 14.5211 26.2444 14.5213 26.2443C14.5216 26.2439 14.5221 26.2435 14.5228 26.2428C14.5241 26.2416 14.5261 26.2397 14.5287 26.2373C14.5339 26.2324 14.5415 26.2252 14.5516 26.2157C14.5717 26.1968 14.6013 26.1687 14.6399 26.1318C14.717 26.0581 14.8299 25.9495 14.9734 25.809C15.2603 25.528 15.6698 25.1196 16.161 24.609C17.143 23.5882 18.453 22.1575 19.7637 20.5188C21.0738 18.8809 22.3886 17.0301 23.377 15.1693C24.3631 13.3128 25.037 11.423 25.037 9.71312H24.537C24.537 11.3032 23.9063 13.107 22.9354 14.9347C21.9669 16.7581 20.6725 18.5821 19.3733 20.2065C18.0747 21.83 16.7755 23.249 15.8006 24.2624C15.3133 24.7689 14.9074 25.1738 14.6236 25.4517C14.4816 25.5907 14.3703 25.6979 14.2945 25.7703C14.2567 25.8064 14.2277 25.8339 14.2083 25.8522C14.1986 25.8614 14.1913 25.8683 14.1864 25.8728C14.184 25.8751 14.1822 25.8768 14.181 25.8779C14.1804 25.8784 14.18 25.8789 14.1797 25.8791C14.1796 25.8792 14.1795 25.8793 14.1794 25.8794C14.1794 25.8794 14.1794 25.8794 14.35 26.0621ZM25.037 9.71375C25.0432 7.29507 23.9068 4.98458 21.8979 3.28956L21.5754 3.67171C23.4837 5.28184 24.5428 7.45698 24.537 9.71248L25.037 9.71375ZM21.8979 3.28956C19.8903 1.59563 17.1734 0.651775 14.3496 0.656894L14.3505 1.15689C17.0663 1.15197 19.6658 2.06048 21.5754 3.67171L21.8979 3.28956ZM14.35 12.6122C12.3853 12.6122 10.8677 11.2761 10.8677 9.71312H10.3677C10.3677 11.6285 12.1921 13.1122 14.35 13.1122V12.6122ZM10.8677 9.71312C10.8677 8.15011 12.3853 6.814 14.35 6.814V6.314C12.1921 6.314 10.3677 7.79772 10.3677 9.71312H10.8677ZM14.35 6.814C16.3147 6.814 17.8323 8.15011 17.8323 9.71312H18.3323C18.3323 7.79772 16.5079 6.314 14.35 6.314V6.814ZM17.8323 9.71312C17.8323 10.467 17.4777 11.2006 16.8279 11.7488L17.1504 12.131C17.9005 11.4981 18.3323 10.6297 18.3323 9.71312H17.8323ZM16.8279 11.7488C16.1769 12.2981 15.286 12.6122 14.35 12.6122V13.1122C15.3938 13.1122 16.4015 12.7628 17.1504 12.131L16.8279 11.7488Z"
				fill="#333333"
				fillOpacity="0.7"
			/>
		</g>
		<defs>
			<filter
				id="filter0_d_21_35"
				x="2.66296"
				y="0.65686"
				width="29.3741"
				height="33.7474"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx="3" dy="4" />
				<feGaussianBlur stdDeviation="2" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_21_35"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_21_35"
					result="shape"
				/>
			</filter>
		</defs>
	</svg>
)

IconPinLocator.propTypes = {
	color: PropTypes.string,
	size: PropTypes.number
}

IconPinLocator.defaultProps = {
	size: 33,
	color: "white"
}

export default IconPinLocator
